import * as Sentry from '@sentry/react'
import type { RootOptions } from 'react-dom/client'

/**
 * Error reporting to Sentry. Only production builds with VITE_SENTRY_DSN report (the deploy sets
 * it from SENTRY_CP_DSN), so local development never uses the monthly allowance. Errors only:
 * no performance tracing or session replays, and none of the personal data the SDK would collect
 * by default (user details and IP address, cookies, headers, bodies, query strings, variables).
 */
const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined

export const sentryEnabled = Boolean(dsn) && import.meta.env.PROD

export function initSentry() {
  if (!sentryEnabled) return

  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) || 'production',
    release: (import.meta.env.VITE_SENTRY_RELEASE as string | undefined) || undefined,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false,
      stackFrameVariables: false,
    },
  })
}

/** Errors that escape every error boundary (route errors are reported by RouteErrorBoundary). */
export const rootErrorOptions: RootOptions = sentryEnabled
  ? { onUncaughtError: Sentry.reactErrorHandler() }
  : {}

export function reportError(error: unknown) {
  if (sentryEnabled) Sentry.captureException(error)
}
